export const assetsPathPrefix = "/assets/pages/";

export const getFullSizeImagePath = (pageStem, lessMD) =>
  `${assetsPathPrefix}${pageStem}${lessMD ? "_mobile" : ""}.jpg`;

export const getPlaceholderImagePath = (pageStem, lessMD) =>
  `${assetsPathPrefix}${pageStem}${lessMD ? "_mobile" : ""}_tiny.jpg`;
